import { render, staticRenderFns } from "./PrijavaBase.vue?vue&type=template&id=2d6bc8a3&scoped=true&"
import script from "./PrijavaBase.vue?vue&type=script&lang=js&"
export * from "./PrijavaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bc8a3",
  null
  
)

export default component.exports